<div class="DashBoardMn" style="background-color:#ededed !important;">
        <div class="DashboardInner">
            <div class="page-header">
                <ion-grid class="login-header">
                    <ion-row class="ion-align-items-center">
                        <!--ITI LOGO-->
                        <ion-col>
                            <img src="assets/images/on-boarding/logo_ITI.png" alt="ITI-logo">
                        </ion-col>
                        <!--ITI MAIL & PHONE INFO-->
                        <ion-col class="ion-text-end">
                                <a class="inline-flex margin-right-30" href="mailto:mfassist@itiorg.com">
                                    <img class="padding-right-10" src="assets/images/on-boarding/Email.svg">
                                    mfassist@itiorg.com
                                </a>
                                <a class="inline-flex" href="tel:1800 266 9603">
                                    <img  class="padding-right-10" src="assets/images/on-boarding/call.svg">
                                    1800 266 9603    
                                </a> 
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
            <div class="payment-disclosure-container">
                <h1>Payment Modes and their efficiency Lump Sum Transactions - Non Liquid Schemes</h1> <br />
                <div class="tablescroll">
                    <table style="width: 90%; border: 1px solid #CCCCCC; padding: 10px;">
                        <tr class="gridth" style=" background: #778561;  color: #000;">
                        <td>Sr No.</td>
                        <td>Payment Mode</td>
                        <td>Bank Name</td>
                        <td>Cut off Time</td>
                        <td>Day of Debit to Investor's Account</td>
                        <td>Day of Unit Allotment</td>
                        </tr>
                        <tr class="gridtd2" style=" background: #e9e9e9;  color: #000;">
                        <td>1</td>
                        <td>UPI / IMPS</td>
                        <td>All Banks</td>
                        <td>2:45 PM</td>
                        <td>T</td>
                        <td>T</td>
                        </tr>
                        <tr class="gridtd2" style=" background:#f7f7f7 ;  color: #000;">
                        <td>2</td>
                        <td>Net Banking*</td>
                        <td>HDFC BANK</td>
                        <td>2:45 PM</td>
                        <td>T</td>
                        <td>T</td>
                        </tr>
                        <tr class="gridtd2" style=" background: #e9e9e9;  color: #000;">
                        <td></td>
                        <td></td>
                        <td>ICICI Bank</td>
                        <td>2:45 PM</td>
                        <td>T</td>
                        <td>T</td>
                        </tr>
                        <tr class="gridtd2" style=" background:#f7f7f7 ;  color: #000;">
                        <td></td>
                        <td></td>
                        <td>KOTAK Bank</td>
                        <td>2:45 PM</td>
                        <td>T</td>
                        <td>T</td>
                        </tr>
                        <tr class="gridtd2" style=" background: #e9e9e9;  color: #000;">
                        <td></td>
                        <td></td>
                        <td>AXIS Bank</td>
                        <td>2:45 PM</td>
                        <td>T</td>
                        <td>T</td>
                        </tr>
                        <tr class="gridtd2" style=" background: #f7f7f7 ;  color: #000;">
                        <td></td>
                        <td></td>
                        <td>YES Bank</td>
                        <td>2:45 PM</td>
                        <td>T</td>
                        <td>T</td>
                        </tr>
                        <tr class="gridtd2" style=" background:#e9e9e9;  color: #000;">
                        <td></td>
                        <td></td>
                        <td>STATE BANK OF INDIA</td>
                        <td>2:45 PM</td>
                        <td>T</td>
                        <td>T</td>
                        </tr>
                        <tr class="gridtd2" style=" background:#f7f7f7;  color: #000;">
                        <td></td>
                        <td></td>
                        <td>IDFC Bank</td>
                        <td>2:45 PM</td>
                        <td>T</td>
                        <td>T</td>
                        </tr>
                        <tr class="gridtd2" style=" background:#e9e9e9;  color: #000;">
                        <td></td>
                        <td></td>
                        <td>IDBI Bank</td>
                        <td>2:45 PM</td>
                        <td>T</td>
                        <td>T</td>
                        </tr>
                        <tr class="gridtd2" style=" background:#f7f7f7;  color: #000;">
                        <td></td>
                        <td></td>
                        <td>Indusind Bank</td>
                        <td>2:45 PM</td>
                        <td>T</td>
                        <td>T</td>
                        </tr>
                        <tr class="gridtd2" style=" background: #e9e9e9 ;  color: #000;">
                        <td></td>
                        <td></td>
                        <td>OTHER Banks</td>
                        <td>3:00 PM</td>
                        <td>T</td>
                        <td>T+1</td>
                        </tr>
                        <tr class="gridtd2" style=" background:#e9e9e9;  color: #000;">
                        <td>3</td>
                        <td>RTGS </td>
                        <td>All Banks</td>
                        <td>2:30 PM</td>
                        <td>T</td>
                        <td>T</td>
                        </tr>
                        <tr class="gridtd2" style=" background: #f7f7f7 ;  color: #000;">
                        <td>4</td>
                        <td>NEFT</td>
                        <td>All Bank</td>
                        <td>1:00 PM</td>
                        <td>T</td>
                        <td>T</td>
                        </tr>
                        <tr class="gridtd2" style=" background:#e9e9e9;  color: #000;">
                        <td>5</td>
                        <td>NACH MANDATE</td>
                        <td>All Banks</td>
                        <td>3:00 PM</td>
                        <td>T+1</td>
                        <td>T+2</td>
                        </tr>
                        <tr class="gridtd2" style=" background:#f7f7f7 ;  color: #000;">
                        <td>5</td>
                        <td>Cheque Mode</td>
                        <td>All Banks</td>
                        <td>3:00 PM</td>
                        <td>T+2</td>
                        <td>T+3</td>
                        </tr>
                    </table>
                </div>
                <div class="text-black" style="color: #000 !important; ">
                    <br />
                    <h2>T = Date of application based on cut-off time</h2>
                    <h3>
                       * While these 9 banks are technically enabled to provide real time credit, not all PA/AMC may be integrated with all the banks in which case the date of credit to MF account / unit allotment will happen on T + 1
                    </h3>
                    <h3>   Important Note: Unit allotment will be subject to receipt of funds in the mutual fund account before the applicable cut-off time (Currently, 3:00 PM)</h3>
                 </div>
                 <div>
                    <div>
                       <h1>Payment Modes and their efficiency SIP Transactions</h1>
                    </div>
                    <div>
                       <table style="width: 90%;margin-top: 11px;">
                          <tr class="gridth" style=" background: #778561;  color: #000;">
                             <td>Sr. No.</td>
                             <td>Payment Mode</td>
                             <td>Bank Name</td>
                             <td>Day of Debit to Investor's Account</td>
                             <td>Day of Unit Allotment</td>
                          </tr>
                          <tr class="gridtd2" style=" background: #e9e9e9;  color: #000;">
                             <td>1</td>
                             <td>NACH (Physical / E-NACH)*</td>
                             <td>All</td>
                             <td>T</td>
                             <td>T+1</td>
                          </tr>
                          <tr class="gridtd2" style=" background: #f7f7f7;  color: #000;">
                             <td>2</td>
                             <td>Auto Debit</td>
                             <td>All</td>
                             <td>T</td>
                             <td>T</td>
                          </tr>
                          <tr class="gridtd2" style=" background: #e9e9e9;  color: #000;">
                             <td>3</td>
                             <td>Internet SIP (ISIP)</td>
                             <td>All</td>
                             <td>T</td>
                             <td>T+1</td>
                          </tr>
                       </table>
                       <br />
                       <div class="text-black" style="color: #000 !important;"> 
                          <h2>T = SIP date</h2>
                          <h3>* MF / NPCI will endevaour to ensure credit is posted to MF account on the same day of debit to investor's account. In certain circumstances, due to delay at Bank's / Payment Aggregator's end, the credit to MF account may and the allotment could get delayed to T+1.</h3>
                          <h3>Important Note: Unit allotment will be subject to receipt of funds in the mutual fund account before the applicable cut-off time (Currently, 3:00 PM)</h3>
                       </div>
                    </div>
                 </div>
            </div>
        </div>
</div>
<page-template-footer class="page--footer-color-white">
   <div class="disclaimers-footer-content" style="background-color:#fff !important;">
      <div class="disclaimers-footer-content-left">© {{currentYear}}  ITI Mutual Fund. All Rights Reserved.</div>
      <div class="disclaimers-footer-content-right">
         <a href="#/login/privacy-policy" target="_blank">Privacy policy</a>  <span style="color: #000 !important;">|</span> 
         <a href="#/login/terms-and-condition" target="_blank">Terms and Condition</a> <span style="color: #000 !important;">|</span>
         <a href="#/login/disclaimer" target="_blank">Disclaimer</a> <span style="color: #000 !important;">|</span>
         <a href="#/login/risk-factors" target="_blank">Risk Factors</a>
      </div>
   </div>
</page-template-footer>
